var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.833,
    height: 29.834,
    viewBox: "0 0 29.833 29.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.224,
    y1: 0.618,
    x2: 1,
    y2: 0.802,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97a1c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97a1c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.377,
    y1: 0.15,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.224,
    y1: 0.618,
    x2: 1,
    y2: 0.802,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b79ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#7465d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463d80"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3083",
    "data-name": "Group 3083",
    transform: "translate(-1525.998 -40.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1906",
    "data-name": "Group 1906",
    transform: "translate(-19617.842 -6045.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_profile-circle",
    "data-name": "vuesax/bulk/profile-circle",
    transform: "translate(20651.84 5834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-circle",
    transform: "translate(492 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.861,12.431A12.431,12.431,0,1,1,12.431,0,12.431,12.431,0,0,1,24.861,12.431Z",
    transform: "translate(2.486 2.499)",
    fill: "#4f53cd",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.661,0A4.655,4.655,0,0,0,4.6,9.311h.224A4.657,4.657,0,0,0,4.661,0Z",
    transform: "translate(10.255 8.627)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H29.834V29.834H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3279",
    "data-name": "Rectangle 3279",
    width: 8.585,
    height: 8.585,
    rx: 4,
    transform: "translate(10.624 8.989)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M16.856,4.655A12.4,12.4,0,0,1,8.428,7.949,12.4,12.4,0,0,1,0,4.655,5.314,5.314,0,0,1,2.287,1.7a11.96,11.96,0,0,1,12.281,0A5.26,5.26,0,0,1,16.856,4.655Z",
    transform: "translate(6.489 19.411)",
    fill: "url(#linear-gradient-3)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccount);
export default __webpack_public_path__ + "static/media/my-account.2e09efaa3bf32cc989f65fb5283305fa.svg";
export { ForwardRef as ReactComponent };